import {
  TRANSACTION_FAILED,
  TRANSACTION_INVALID_REQUEST,
  TRANSACTION_SUCCESS,
  NETWORK_ERROR_TRANSACTION,
  TRANSACTION_NOT_FOUND,
  RESET_TRANSACTION,
  LOADING_TRANSACTION
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  data: {},
  networkError: "",
  notFound: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_TRANSACTION:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        data: {},
        networkError: "",
        notFound: false
      };

    case TRANSACTION_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        networkError: "",
        notFound: false
      };

    case TRANSACTION_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: true,
        networkError: "",
        notFound: false
      };

    case TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: Array.isArray(action.payload.Response)
          ? action.payload.Response
          : [].concat(action.payload.Response),
        networkError: "",
        notFound: false
      };

    case NETWORK_ERROR_TRANSACTION:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong..Check network connectivity",
        notFound: false
      };

    case TRANSACTION_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        data: {},
        failed: false,
        success: false,
        invalidRequest: false,
        notFound: true
      };

    case RESET_TRANSACTION:
      return (state = initialState);

    default:
      return state;
  }
};
